/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
  /**
   * The HTTP status code.
   * @type {number}
   * @memberof ErrorResponse
   */
  code: number;
  /**
   * The error message.
   * @type {string}
   * @memberof ErrorResponse
   */
  error: ErrorResponseErrorEnum;
  /**
   * The details of the error.
   * @type {string}
   * @memberof ErrorResponse
   */
  detail?: string;
}

export const ErrorResponseErrorEnum = {
  BadRequest: 'Bad Request',
  FileExpired: 'File Expired',
  Forbidden: 'Forbidden',
  ResourceLocked: 'Resource Locked',
  FormatNotSupported: 'Format Not Supported',
  InternalServerError: 'Internal Server Error',
  JobError: 'Job error',
  JobExpired: 'Job Expired',
  JobInProgress: 'Job In Progress',
  JobIsNotOfTypeAlignment: 'Job is not of type alignment',
  JobIsNotOfTypeTranscription: 'Job is not of type transcription',
  JobNotFound: 'Job not found',
  JobRejected: 'Job rejected',
  JobRejectedDueToInvalidAudio: 'Job rejected due to invalid audio',
  JobRejectedDueToInvalidText: 'Job rejected due to invalid text',
  MalformedRequest: 'Malformed request',
  MissingCallback: 'Missing callback',
  MissingDataFile: 'Missing data_file',
  MissingTextFile: 'Missing text_file',
  NoLanguageSelected: 'No language selected',
  NotImplemented: 'Not Implemented',
  PermissionDenied: 'Permission Denied',
  RequestedProductNotAvailable: 'Requested product not available',
  TranscriptionNotReady: 'Transcription not ready',
  LogFileNotAvailable: 'Log file not available',
  UnprocessableEntity: 'Unprocessable Entity',
  MaxConcurrentRunningJobsExceeded: 'Max concurrent running jobs exceeded',
} as const;

export type ErrorResponseErrorEnum =
  (typeof ErrorResponseErrorEnum)[keyof typeof ErrorResponseErrorEnum];
